export default {
  viewBase: {
    'a1': 'Health Dynamics',
    'a2': 'Cancel',
    'a3': 'Delete',
    'a4': 'Add family members',
    'a5': 'HRV heart index',
    'a6': 'Not measured',
    'a7': 'Number of apnea',
    'a8': 'Time',
    'a9': 'Apnea',
    'a10': 'hrv',
    'a11': 'Glucose',
    'a12': 'Heart rate',
    'a13': 'ECG',
    'a14': 'Heart load',
    'a15': 'Blood Oxygen',
    'a16': 'Arteriosclerosis Index',
    'a17': 'sos warning',
    'a18': 'Health analysis',
    'a19': 'Blood pressure',
    'a20': 'Normal',
    'a21': 'Higher',
    'a22': 'Lower',
    'a23': 'BMI',
    'a24': 'Sport',
    'a25': 'Successfully deleted',
    'a26': 'Deletion failed',
    'a27': 'You have no family members to edit',
    'a28': 'Choose family relationship',
    'a29': 'Family relationship',
    'a30': 'Please enter your mobile number',
    'a31': 'Mobile number',
    'a32': 'Bind now',
    'a33': 'Male',
    'a34': 'Female',
    'a35': 'Family relationship is not selected',
    'a36': 'Mobile phone number format error',
    'a37': 'Binding successful',
    'a38': 'Reject',
    'a39': 'Agree',
    'a40': 'Added',
    'a41': 'Rejected',
    'a42': 'Are you sure to delete? ',
    'a43': 'Loading ...',
    'a44': 'Are you sure to refuse family relations? ',
    'a45': 'Are you sure you agree to family relations? ',
    'a46': 'Already finished',
    'a47': 'No data yet',
    'a48': 'Week',
    'a49': 'Month',
    'a50': 'Start time',
    'a51': 'End time',
    'a52': 'Trend Statistics',
    'a53': 'Data analysis',
    'a54': 'Project',
    'a55': 'This week',
    'a56': 'This month',
    'a57': 'Last week',
    'a58': 'Last month',
    'a59': 'Total measurement (times)',
    'a60': 'Normal (time)',
    'a61': 'Exception (time)',
    'a62': 'Average value',
    'a63': 'Highest value',
    'a64': 'Lowest value',
    'a65': 'Step',
    'a66': 'Save',
    'a67': 'Avatar',
    'a68': 'Name',
    'a69': 'Please enter your name',
    'a70': 'Dirty sound',
    'a71': 'Select gender',
    'a72': 'Please select',
    'a73': 'Please enter detailed address',
    'a74': 'Name is not filled in',
    'a75': 'Gender is not selected',
    'a76': 'Birthday not selected',
    'a77': 'Success',
    'a78': 'Detailed address',
    'a79': 'Gender',
    'a80': 'Birthday',
    'a81': 'OK',
    'a82': 'Longitude',
    'a83': 'Latitude',
    'a84': 'Total',
    'a85': 'Average',
    'a86': 'High value',
    'a87': 'Low value',
    'a88': 'Normal',
    'a89': 'Exception',
    'a90': 'Time query',
    'a91': 'Number of steps',
    'a92': 'Manual entry',
    'a93': 'Please enter the number of steps',
    'a94': 'Processing failed, please try again'
  }
}
